/* import __COLOCATED_TEMPLATE__ from './category-drop-header.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import discourseComputed from "discourse-common/utils/decorators";
import ComboBoxSelectBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
const CategoryDropHeader = dt7948.c(class CategoryDropHeader extends ComboBoxSelectBoxHeaderComponent {
  categoryBackgroundColor(categoryColor) {
    return categoryColor || "#e9e9e9";
  }
  static {
    dt7948.n(this.prototype, "categoryBackgroundColor", [discourseComputed("selectedContent.color")]);
  }
  categoryTextColor(categoryTextColor) {
    return categoryTextColor || "#333";
  }
  static {
    dt7948.n(this.prototype, "categoryTextColor", [discourseComputed("selectedContent.text_color")]);
  }
}, [classNames("category-drop-header")]);
export default CategoryDropHeader;